import { cn } from '../../lib/cn';
import { useHaptics } from '../../hooks/useHaptics';

/** iOS-style toggle. Visual track is 51×31; the button is padded to a 44px touch target. */
export function Switch({
  checked,
  onChange,
  label,
  className
}: {
  checked: boolean;
  onChange: (v: boolean) => void;
  label: string;
  className?: string;
}) {
  const { impact } = useHaptics();
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      onClick={() => {
        void impact('selection');
        onChange(!checked);
      }}
      className={cn(
        'inline-flex shrink-0 items-center justify-center border-0 bg-transparent p-[6.5px] outline-none',
        'active:opacity-80',
        className
      )}
    >
      <span
        aria-hidden
        className={cn(
          'relative block h-[31px] w-[51px] rounded-full transition-colors duration-200 ease-out',
          checked ? 'bg-accent' : 'bg-[#E9E9EA]'
        )}
      >
        <span
          className={cn(
            'absolute left-[2px] top-[2px] h-[27px] w-[27px] rounded-full bg-white shadow-[0_3px_8px_rgba(0,0,0,0.15),0_1px_1px_rgba(0,0,0,0.16)]',
            'transition-transform duration-200 ease-ios-out',
            checked ? 'translate-x-[20px]' : 'translate-x-0'
          )}
        />
      </span>
    </button>
  );
}
